import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useDocumentTitle = (title: string): void => {
  const { t } = useTranslation();
  const shown = t('passcodeAuth.documentTitle', '{{title}} · DigitalPaani', { title });
  useEffect(() => {
    const previous = document.title;
    document.title = shown;
    return () => {
      document.title = previous;
    };
  }, [shown]);
};
